import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MapMarker } from '@components/common';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import GoogleMap from 'google-map-react';
import { constants, utils } from '../../utils';
import PingListItem from './PingListItem';

class PingsMap extends Component {
	shouldComponentUpdate({ locationDetails, timeZoneId }) {
		const lastProps = this.props;
		return (
			!isEqual(locationDetails, lastProps.locationDetails)
			|| !isEqual(timeZoneId, lastProps.timeZoneId)
		);
	}

	applyJobPointsFilter = (filter) => {
		const { locationDetails, onClickItem } = this.props;
		let newCenter = constants.GOOGLE_MAP_SETTINGS.defaultCenter;

		if (filter === 'all') {
			newCenter = {
				lat : locationDetails.job.location.lat,
				lng : locationDetails.job.location.lng,
			};
		} else {
			const points = locationDetails.points.filter((item) => item.type === filter);

			if (points.length > 0) newCenter = points[0].location;
		}

		const propsToUpdate = [{ property : 'locationDetails.filter', value : filter }];

		if (newCenter) propsToUpdate.push({ property : 'locationDetails.mapCenter', value : newCenter });

		onClickItem(propsToUpdate);
	}

	render() {
		const { locationDetails, timeZoneId, onClickItem } = this.props;
		const {
			filter, mapCenter, highlightedMarker, options, points,
		} = locationDetails;

		let filteredPoints = points;

		if (filter === 'checkin') filteredPoints = points.filter((item) => (item.type === 'job' || item.type === 'checkin' || item.type === 'checkout'));
		else if (filter === 'ping') filteredPoints = points.filter((item) => (item.type === 'job' || item.type === 'ping'));

		return (
			<div className="flex flex-wrap padding-top-5 padding-bottom-50 padding-left-20 padding-right-20">
				<div className="flex-3">
					<div className="height-400 width-min-250">
						<GoogleMap
							zoom={15}
							center={mapCenter}
							bootstrapURLKeys={{ key : constants.GOOGLE_MAP_SETTINGS.key }}
							options={constants.GOOGLE_MAP_OPTIONS}
						>
							<For
								each="item"
								of={filteredPoints}
							>
								<MapMarker
									key={`jobEvent_point_${item.id}`}
									type={item.type}
									lat={item.location.lat}
									lng={item.location.lng}
									useHover
									highlightMarker={highlightedMarker === item.id}
									message={item.type === 'job'
										? null
										: utils.parseUTCDateToTimeZone(item.dateTime, timeZoneId).format('MMMM Do YYYY, h:mm a')}
								/>
							</For>
						</GoogleMap>
					</div>
				</div>
				<div className="flex-2 location-details-map-sidebar">
					<div className="filter-options">
						<For
							index="index"
							each="item"
							of={options}
						>
							<Button
								key={`jobPoints_button_${item.value}`}
								onClick={() => this.applyJobPointsFilter(item.value)}
								className={classNames('filter-button', { 'btn-active' : filter === item.value })}
								bsStyle={null}
							>
								{ item.label }
							</Button>
						</For>
					</div>
					<div className="point-selector-container">
						<For
							each="item"
							of={filteredPoints}
						>
							<PingListItem
								key={`jobPoints_list_item_${item.id}`}
								item={item}
								timeZoneId={timeZoneId}
								onClick={onClickItem}
							/>
						</For>
					</div>
				</div>
			</div>
		);
	}
}

PingsMap.propTypes = {
	locationDetails : PropTypes.object.isRequired,
	onClickItem     : PropTypes.func.isRequired,
	timeZoneId      : PropTypes.string,
};

PingsMap.defaultProps = {
	timeZoneId : '',
};

export default PingsMap;
